import React from 'react';
import styled from 'styled-components';

import { Mask } from '../../lib/components/LessonPath/static/style';

import { H5PageLink } from '../../static/json/page-link';
import { ContentBox, ContentClose, ButtonBox, Button } from './static/style';
import utils from '../../lib/utils';

const BuyCourse = (props) => {
    return (
        <Mask zIndex='999'>
            <ContentBox>
                <LessonTitle>Level {props.level || 'K'}</LessonTitle>
                <Tips>剩余节数不足</Tips>
                <Text>购买节数，继续学习</Text>
                <TipsSmall>现在邀请好友注册，即可获得免费节数！</TipsSmall>
                <ButtonBox>
                    <Button
                        type='left'
                        onClick={() => { window.location.href = 'https://www.putaoabc.com/onlinepages/activity/invite_friend_app/reward_class.html?v=' + utils.getRandom() }}
                    >
                        免费赚节数
                    </Button>
                    <Button
                        type='right'
                        onClick={() => { window.open(H5PageLink.buyCourse) }}
                    >
                        购买节数
                    </Button>
                </ButtonBox>
                <ContentClose onClick={() => props.closeBuyCourseHandler()} />
            </ContentBox>
        </Mask>
    );
}

export default BuyCourse;

const LessonTitle = styled.div`
    margin: 2.44rem 0 0.64rem;
    font-size: 0.4rem;
    font-weight: 500;
`;

const Tips = styled.div`
    font-size: 0.45rem;
    font-style: italic;
    color: #9B64FA;
    line-height: 0.36rem;
`;

const Text = styled.div`
    font-size: 0.34rem;
    line-height: 0.34rem;
    margin: 0.64rem 0 0.17rem;
`;

const TipsSmall = styled.div`
    font-size: 0.28rem;
    color: #FF7878;
`;



// WEBPACK FOOTER //
// ./src/components/dialog/BuyCourse.js